import { render, staticRenderFns } from "./StudentAboutYou.vue?vue&type=template&id=5f5af1ea&scoped=true"
import script from "./StudentAboutYou.vue?vue&type=script&lang=js"
export * from "./StudentAboutYou.vue?vue&type=script&lang=js"
import style0 from "./StudentAboutYou.vue?vue&type=style&index=0&id=5f5af1ea&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5f5af1ea",
  null
  
)

export default component.exports